// Derive a stable error_class enum from fetch failure shape.
// Pure module — extracted from lib/signal.js for hermetic vitest import
// (signal.js is "use client" with React hooks, can't parse in test env).
//
// 4xx_response is enumerated for future expansion; current interceptor
// only emits on >=500 responses (fetch resolves on 4xx, doesn't throw).
export function deriveFetchErrorClass({ status, errorName } = {}) {
  if (status >= 500) return "5xx_response";
  if (status >= 400) return "4xx_response";
  if (errorName === "TimeoutError") return "timeout";
  if (errorName === "AbortError") return "abort";
  if (errorName === "TypeError") return "network_error";
  return "other";
}
